// Shared mapping from OCR-extracted report fields to product fields.

export const APP_ALIAS = [
  ["milk", "milk_tea_blend"], ["retail", "retail_pack"], ["loose", "loose_tea"], ["stall", "tea_stall_hotel"],
  ["hotel", "tea_stall_hotel"], ["premium", "premium_blend"], ["wholesale", "wholesale_supply"], ["export", "export"],
  ["private", "private_label"], ["institution", "institutional_supply"], ["catering", "institutional_supply"],
  ["blending", "blending_purpose"], ["household", "retail_pack"], ["daily", "retail_pack"],
];

export const OCR_TO_PRODUCT = ["garden", "brand_group", "grade", "invoice_no", "lot_no", "net_qty",
  "certification", "report_date", "tea_category", "liquor_color", "body", "strength", "briskness",
  "taste_aroma", "milk_suitability", "selling_note"];

export function mapApplications(arr) {
  const out = new Set();
  (arr || []).forEach((s) => {
    const t = String(s).toLowerCase();
    for (const [kw, val] of APP_ALIAS) {
      if (t.includes(kw)) { out.add(val); break; }
    }
  });
  return [...out];
}

export function ocrToProductPatch(o, existing = {}) {
  o = o || {};
  const patch = {};
  OCR_TO_PRODUCT.forEach((k) => { if (o[k]) patch[k] = o[k]; });
  if (o.no_of_bags) patch.chest_bag = o.no_of_bags;
  const apps = mapApplications(o.commercial_applications);
  if (apps.length) patch.best_application = Array.from(new Set([...(existing.best_application || []), ...apps]));
  return patch;
}
